import { Component, inject } from '@angular/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { TranslatePipe } from '@ngx-translate/core';
import { CDN_URL } from '@maximizer/core/shared/domain';
import { BookDemoDirective } from '../../directives/book-demo.directive';

@Component({
  selector: 'maximizer-showcase-investments-page',
  standalone: true,
  imports: [KENDO_BUTTON, TranslatePipe, BookDemoDirective],
  templateUrl: './investments.page.html',
  styleUrls: ['./investments.page.scss'],
})
export class InvestmentsPage {
  readonly cdn = inject(CDN_URL);
}
